/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import { Link as RouterLink, Navigate } from "react-router-dom";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import MDTypography from "../../../components/MDTypography";
import MDAvatar from "../../../components/MDAvatar";
import MDBadge from "../../../components/MDBadge";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import DeleteModal from "../../../components/MDModal";
import React, { useState, useEffect } from "react";
import { getAllTenant } from "../../../apis/tenant";
import { deleteTenant } from "../../../apis/tenant";
import { useMaterialUIController } from "../../../context";
import MDSnackbar from "../../../components/MDSnackbar";
import { selectVendor, logout } from "../../../redux/userSlice";
import { useSelector, useDispatch } from "react-redux";

export default function data(deleteStatusForTenant, checkIsDataPresent) {
	const dispatch = useDispatch();
	const vendor = useSelector(selectVendor);
	// console.log("vendor details",vendor);
	const [deleteemail, setDeleteEmail] = useState();
	const [open, setOpen] = useState(false);
	const [tenants, setTenants] = useState([]);
	const [controller] = useMaterialUIController();
	const { darkMode } = controller;
	const handleConfirmDelete = async (tenantObject) => {
		setOpen(false);
		try {
			deleteStatusForTenant("inprogress");
			let res = await deleteTenant({ tenantObject });
			if (res.status === 200) {
				// setSuccessSB(true);
				deleteStatusForTenant("deleted");
			} else {
				deleteStatusForTenant("notDeleted");
			}
		} catch (error) {
			console.log("error in delete tenant", error);
			// setErrorSB(true);
			deleteStatusForTenant("notDeleted");
			if (error.response.status === 403) {
				console.log("Unauthorised: Logging Out");
				dispatch(logout());
				localStorage.removeItem("persist:root");
				localStorage.clear();
				window.location.href = "/sign-in";
			}
		}
		// deleteTenant({ tenantObject })
		//   .then((result) => {
		//     if (result.status === 200) {
		//       console.log("Deleted Successfully");
		//       window.location.href = "/sign-in";;
		//     }
		//   })
		//   .catch((error) => {
		//     console.log(error);
		//   });
	};

	useEffect(() => {
		getAllTenant()
			.then((response) => {
				if (response.status === 200) {
					response.data.tenants.sort((a, b) =>
						a.orgName.localeCompare(b.orgName)
					);
					// console.log("data for tenants", response.data);
					setTenants(response.data.tenants);
				}
			})
			.catch((error) => {
				// alert(
				//   `Oops, an error occured while loading the page. Please try again after some time.`
				// );
				checkIsDataPresent("false");
				if (error.response.status === 403) {
					console.log("Unauthorised: Logging Out");
					dispatch(logout());
					localStorage.removeItem("persist:root");
					localStorage.clear();
					window.location.href = "/sign-in";
				}
			});
	}, []);

	const Author = ({ image, name, email, id }) => (
		<MDBox display="flex" alignItems="center" lineHeight={1}>
			<MDAvatar src={image} name={name} size="md" />
			<MDBox ml={2} lineHeight={1}>
				<MDTypography
					display="block"
					variant="button"
					fontWeight="medium"
				>
					{name}
				</MDTypography>
				<MDTypography
					display="block"
					variant="button"
					fontWeight="regular"
				>
					{id}
				</MDTypography>
				<MDTypography variant="caption">{email}</MDTypography>
			</MDBox>
		</MDBox>
	);

	const Job = ({ title, description }) => (
		<MDBox lineHeight={1} ml={2} >
			<MDTypography
				display="block"
				variant="caption"
				color="text"
				fontWeight="medium"
				align="center"
			>
				{title}
			</MDTypography>
			<MDTypography variant="caption">{description}</MDTypography>
		</MDBox>
	);

	return {
		columns: [
			{
				Header: "Organization Name",
				accessor: "author",
				width: "45%",
				align: "left",
			},

			{ Header: "Tier", accessor: "function", align: "center" },
			// { Header: "Tenant Id", accessor: "TenantId", align: "center" },
			{ Header: "Domain", accessor: "status", align: "center" },
			{ Header: "Version", accessor: "version", align: "center" },
			{ Header: "Status", accessor: "tenantStatus", align: "center" },
			{ Header: "Update", accessor: "employed", align: "center" },
			{ Header: "Delete", accessor: "action", align: "center" },
		],

		rows: tenants.map((tenant) => ({
			author: (
				<Author
					image={tenant.logoUrl}
					name={tenant.orgName}
					email={tenant.adminEmail}
					id={tenant.subdomain}
				/>
			),
			function: <Job title={tenant.tier} description="" />,
			// TenantId: <Job title={tenant.subdomain} description="" />,
			status: (
				<Link href={`https://${tenant.domain}`} target="_blank">
					<MDTypography
						variant="button"
						fontWeight="regular"
						color={darkMode ? "white" : "dark"}
					>
						{tenant.domain}
					</MDTypography>
				</Link>
			),
			version: <Job title={tenant?.info?.version} description="" />,

			tenantStatus: (
				<MDButton
					component={RouterLink}
					to={{
						pathname: "/tenant-onboard-status",
						search: `?subdomain=${tenant.subdomain}`,
					}}
					variant="text"
					color={darkMode ? "white" : "dark"}
				>
					<Icon>launch</Icon>&nbsp;
				</MDButton>
			),
			employed: (
				<MDButton
					component={RouterLink}
					to="/edit-tenant"
					state={{ tenant }}
					variant="text"
					color={darkMode ? "white" : "dark"}
					// disabled={!vendor.isAdmin}
					disabled={tenant.tier === "enterprise"}
				>
					<Icon>edit</Icon>&nbsp;
				</MDButton>
			),
			action: (
				<>
					<MDBox mr={1}>
						<MDButton
							variant="text"
							color="error"
							disabled={!vendor.isAdmin}
							onClick={() => {
								setOpen(true);
								setDeleteEmail(tenant);
							}}
						>
							<Icon>delete</Icon>&nbsp;
						</MDButton>
						<DeleteModal
							deleting="tenant"
							open={open}
							onClose={() => setOpen(false)}
							onDelete={() => handleConfirmDelete(deleteemail)}
						/>
					</MDBox>
				</>
			),
		})),
	};
}
